(ns manage.ad-variant.creation.template.table
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/AlertTitle$default" :as AlertTitle]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            ["src/svg/objects/rectangle-split-top-and-left.svg$default" :as RectangleSplitTopAndLeft]
            [common.queries :refer [use-query]]
            [common.resource.query.adset :as adset-queries]
            [common.widgets.column-renderers :refer [template-duration-renderer]]
            [common.widgets.data-grid :as dg]
            [manage.ad-variant.data :as data]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- ad-builder-has-new-revision? [ad-builder]
  (let [ad-format (get-in ad-builder [:ad-formats 0])
        current-revision-id (get-in ad-format [:current-revision :id])
        latest-revision-id (get-in ad-format [:latest-revision :id])]
    (and (not= latest-revision-id current-revision-id)
         (not (nil? latest-revision-id)))))

(defui render-action-column
  [{:keys [row]}]
  ($ :<>
     (when (ad-builder-has-new-revision? row)
       ($ Stack
          {:direction "row"
           :alignItems "center"
           :gap 1}
          ($ Chip
             {:label "New revision available"
              :variant "subtle"
              :color "primary"
              :sx #js {:fontWeight "600"
                       :textTransform "uppercase"}})
          ($ IconButton
             {:onClick #(rf/dispatch [:ad-variant-creation/update-template-revision [row]])}
             ($ Icon "autorenew"))))
     ($ IconButton
        {:onClick #(rf/dispatch [:ad-variant-creation/delete-ad-builder row])}
        ($ Icon "delete_outline"))))

(defn get-current-revision
  [item]
  (-> item :ad-formats first :current-revision))

(defn- columns [after-effects-templates?]
  (->> [{:field "template"
         :headerName "Template"
         :type "string"
         :minWidth 200
         :flex 2
         :valueGetter (fn [_value row ^js _column ^js _apiRef]
                        (:name row))}
        {:field "format"
         :headerName "Format"
         :type "string"
         :minWidth 200
         :flex 2
         :valueGetter (fn [_value row ^js _column ^js _apiRef]
                        (:urn row))
         :renderCell (fn [^js params]
                       (-> (.-value params) data/ad-builder-urn->title))}
        (when after-effects-templates?
          {:field "duration"
           :headerName "Duration"
           :type "string"
           :width 100
           :valueGetter (fn [_value row ^js _column ^js _apiRef]
                          (get-in row [:ad-formats 0 :current-revision :duration]))
           :renderCell (fn [^js params]
                         (template-duration-renderer (.-value params)))})
        {:field "dimensions"
         :headerName "Dimensions"
         :type "string"
         :minWidth 150
         :flex 1
         :valueGetter (fn [_value row ^js _column ^js _apiRef]
                        (let [{:keys [width height]} (get-current-revision row)]
                          (str width "x" height)))}
        {:field "revision"
         :headerName "Revision"
         :type "number"
         :minWidth 100
         :flex 1
         :valueGetter (fn [_value row ^js _column ^js _apiRef]
                        (:version (get-current-revision row)))}
        {:field "actions"
         :headerName ""
         :type "actions"
         :align "right"
         :minWidth 260
         :renderCell (fn [^js params]
                       ($ render-action-column {:row (.-row params)}))}]
       (filter some?)
       clj->js))

(defn update-with-ui-id
  [ad-builders]
  (mapv #(assoc %1 :ui-id (str (:urn %1) "-" %2)) ad-builders (range (count ad-builders))))

(def Toolbar
  (uix/as-react
   (fn [{:keys [rows]}]
     ($ Stack
        ($ dg/grid-toolbar
           ($ Button
              {:variant "contained"
               :color "grey"
               :component "a"
               :startIcon ($ Icon "add")
               :onClick #(rf/dispatch
                          [:modal/open {:id :ad-variant/add-template-modal}])}
              "Add template"))
        (when (some ad-builder-has-new-revision? rows)
          ($ Alert
             {:icon ($ SvgIcon
                       {:component RectangleSplitTopAndLeft})
              :severity "info"}
             ($ AlertTitle {} "New template revisions available!")
             ($ Button
                {:variant "contained"
                 :startIcon ($ Icon "autorenew")
                 :onClick #(rf/dispatch [:ad-variant-creation/update-template-revision rows])
                 :sx #js {:mt 0.5}}
                "Update all revisions")))))))

(defui ad-formats-datagrid [{:keys [ad-builders-upgrade-hints-reponse]}]
  (let [{:keys [adset-id]} (use-subscribe [:url-context])
        {{:keys [channel]} :data} (use-query (adset-queries/adset-query {:adset-id adset-id}))
        {:keys [isInitialLoading isFetching isError data]} ad-builders-upgrade-hints-reponse
        rows (uix/use-memo (fn []
                             (update-with-ui-id data))
                           [data])

        page-size 10
        no-rows-label (cond
                        isError "Could not load Ad formats"
                        isInitialLoading "Loading Ad formats"
                        (empty? rows) "No Ad formats have been created yet"
                        :else "")

        columns (columns (not= channel "display"))
        get-row-id (fn [row] (:ui-id row))]
    ($ Stack {:flex 1
              :sx #js {:overflow "hidden"}}
       ($ DataGridPremium
          {:columns columns

           :loading isFetching
           :localeText #js {:noRowsLabel no-rows-label}

           :rows (to-array rows)
           :getRowId get-row-id

           :disableRowSelectionOnClick true

           :pagination true
           :pageSizeOptions #js [page-size]
           :data-testid "table-ads"

           :slots #js {:toolbar Toolbar}
           :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input
                           :toolbar #js {:rows rows}}

           :noWrap true}))))
